// src/store/settings/maschines.js
export default {
    namespaced: true,
    state: () => ({
        location: {
            streetnr: '',
            street: '',
            postalcode: '',
            country: '',
            city: ''
        },
        options: []
    }),
    getters: {
        location: (state) => state.location,
        options: (state) => state.options
    },
    mutations: {
        SET_LOCATION(state, payload) {
            state.location = { ...state.location, ...payload }
        },
        UPDATE_LOCATION_FIELD(state, { field, value }) {
            if (Object.prototype.hasOwnProperty.call(state.location, field)) {
                state.location[field] = value
            }
        },
        RESET_LOCATION(state) {
            state.location = { streetnr: '', street: '', postalcode: '', country: '', city: '' }
        },
        SET_OPTIONS(state, options) {
            state.options = Array.isArray(options) ? options.slice() : []
        },
        ADD_OPTION(state, option) {
            state.options.push(option)
        },
        REMOVE_OPTION_BY_INDEX(state, index) {
            if (index >= 0 && index < state.options.length) state.options.splice(index, 1)
        },
        REMOVE_OPTION(state, option) {
            const i = state.options.indexOf(option)
            if (i !== -1) state.options.splice(i, 1)
        }
    },
    actions: {
        setLocation({ commit }, payload) {
            commit('SET_LOCATION', payload)
        },
        updateLocationField({ commit }, payload) {
            commit('UPDATE_LOCATION_FIELD', payload)
        },
        resetLocation({ commit }) {
            commit('RESET_LOCATION')
        },
        setOptions({ commit }, options) {
            commit('SET_OPTIONS', options)
        },
        addOption({ commit }, option) {
            commit('ADD_OPTION', option)
        },
        removeOptionByIndex({ commit }, index) {
            commit('REMOVE_OPTION_BY_INDEX', index)
        },
        removeOption({ commit }, option) {
            commit('REMOVE_OPTION', option)
        }
    }
}